// import dashboard from './dashboard';
import utilities from './utilities';
// import other from './other';
import services from './services';
// import Limit from './LimitManagement';Procurement
import Procurement from './Procuremet'

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    services,
    utilities,
    // Limit
    Procurement,
  ]
};

export default menuItems;
